/*
 * Hilfeartikel in den Suchvorschlägen (Kopf-Suche)
 *
 * Hängt an Dawns Vorschlagsliste (predictive-search) eine eigene Gruppe „Hilfe“
 * mit passenden Artikeln aus dem Goodsmith-Hilfecenter. Dawns Skript bleibt
 * unverändert: Es ersetzt die Liste bei jeder Antwort komplett, deshalb setzen wir
 * die Gruppe nach jedem Neuaufbau wieder ein (MutationObserver).
 *
 * Bei Fehler, Zeitüberschreitung oder ohne Treffer erscheint keine Gruppe.
 */
(function () {
  'use strict';

  var VERZOEGERUNG_MS = 180;
  var TIMEOUT_MS = 4000;
  var MIN_ZEICHEN = 2;
  var MAX_ANZEIGE = 3;

  var skript = document.currentScript;
  if (!skript) return;

  var endpunkt = skript.getAttribute('data-endpoint');
  var sprache = skript.getAttribute('data-locale') || 'de';
  var ueberschrift = skript.getAttribute('data-label') || '';
  if (!endpunkt || !ueberschrift || !window.MutationObserver) return;

  /* Antworten je Suchbegriff, geteilt zwischen allen Suchfeldern der Seite */
  var cache = {};
  var instanzZaehler = 0;

  /* Maskierte Felder (titel, kategorie) kommen als HTML-Entities und sollen als Text erscheinen. */
  function entschluesseln(wert) {
    var el = document.createElement('textarea');
    el.innerHTML = wert == null ? '' : String(wert);
    return el.value;
  }

  /* Nur absolute https-Adressen der Plattform werden verlinkt; eigene Adressen bauen wir nie. */
  function adresseGueltig(adresse) {
    if (typeof adresse !== 'string' || adresse.length === 0) return false;
    try {
      return new URL(adresse, window.location.origin).protocol === 'https:';
    } catch (e) {
      return false;
    }
  }

  function schluessel(begriff) {
    return begriff.trim().toLowerCase();
  }

  /* Baut die Gruppe im Markup von Dawns Vorschlägen, damit Pfeiltasten und Enter mitlaufen. */
  function gruppeBauen(vorschlaege, schl, praefix) {
    var gruppe = document.createElement('div');
    gruppe.className = 'gs-help-suggest';
    gruppe.setAttribute('data-gs-help-suggest', schl);

    var kopf = document.createElement('h2');
    kopf.id = praefix + '-heading';
    kopf.className = 'predictive-search__heading text-body caption-with-letter-spacing';
    kopf.textContent = ueberschrift;
    gruppe.appendChild(kopf);

    var liste = document.createElement('ul');
    liste.className = 'predictive-search__results-list list-unstyled';
    liste.setAttribute('role', 'group');
    liste.setAttribute('aria-labelledby', kopf.id);

    vorschlaege.forEach(function (artikel, index) {
      var eintrag = document.createElement('li');
      eintrag.id = praefix + '-option-' + (index + 1);
      eintrag.className = 'predictive-search__list-item';
      eintrag.setAttribute('role', 'option');
      eintrag.setAttribute('aria-selected', 'false');

      var link = document.createElement('a');
      link.className = 'predictive-search__item link link--text';
      link.href = artikel.adresse;
      link.setAttribute('tabindex', '-1');

      var inhalt = document.createElement('div');
      inhalt.className = 'predictive-search__item-content';

      var titel = document.createElement('p');
      titel.className = 'predictive-search__item-heading gs-help-suggest__title';
      titel.textContent = entschluesseln(artikel.titel);
      inhalt.appendChild(titel);

      if (artikel.kategorie) {
        var thema = document.createElement('span');
        thema.className = 'gs-help-suggest__topic';
        thema.textContent = entschluesseln(artikel.kategorie);
        inhalt.appendChild(thema);
      }

      link.appendChild(inhalt);
      eintrag.appendChild(link);
      liste.appendChild(eintrag);
    });

    gruppe.appendChild(liste);
    return gruppe;
  }

  function einrichten(suche) {
    var eingabe = suche.querySelector('input[type="search"]');
    var ziel = suche.querySelector('[data-predictive-search]');
    if (!eingabe || !ziel) return;

    instanzZaehler += 1;
    var praefix = 'gs-help-suggest-' + instanzZaehler;
    var uhr = null;
    var abbruch = null;

    /* Setzt die Gruppe passend zum aktuellen Begriff ein — oder entfernt sie. */
    function abgleichen() {
      var schl = schluessel(eingabe.value);
      var vorhanden = ziel.querySelector('[data-gs-help-suggest]');
      var daten = schl.length >= MIN_ZEICHEN ? cache[schl] : null;

      if (vorhanden && daten && vorhanden.getAttribute('data-gs-help-suggest') === schl) return;
      if (vorhanden) vorhanden.parentNode.removeChild(vorhanden);
      if (!daten || daten.length === 0) return;

      /* Erst einsetzen, wenn Dawn die Liste für diesen Begriff aufgebaut hat */
      var ergebnisse = ziel.querySelector('#predictive-search-results');
      if (!ergebnisse) return;
      var sucheNachKnopf = ergebnisse.querySelector('#predictive-search-option-search-keywords');
      ergebnisse.insertBefore(gruppeBauen(daten, schl, praefix), sucheNachKnopf);
    }

    function laden(begriff) {
      var schl = schluessel(begriff);
      if (abbruch) abbruch.abort();
      abbruch = new AbortController();
      var eigenerAbbruch = abbruch;
      var zeitlimit = window.setTimeout(function () {
        eigenerAbbruch.abort();
      }, TIMEOUT_MS);

      var adresse =
        endpunkt + '?q=' + encodeURIComponent(begriff.trim()) + '&sprache=' + encodeURIComponent(sprache);

      fetch(adresse, { signal: eigenerAbbruch.signal, headers: { Accept: 'application/json' } })
        .then(function (antwort) {
          if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
          return antwort.json();
        })
        .then(function (daten) {
          window.clearTimeout(zeitlimit);
          var vorschlaege = (daten && Array.isArray(daten.vorschlaege) ? daten.vorschlaege : [])
            .filter(function (artikel) {
              return artikel && artikel.titel && adresseGueltig(artikel.adresse);
            })
            .slice(0, MAX_ANZEIGE);
          cache[schl] = vorschlaege;
          /* Veraltete Antworten nur zwischenspeichern, nicht anzeigen */
          if (schluessel(eingabe.value) === schl) abgleichen();
        })
        .catch(function () {
          window.clearTimeout(zeitlimit);
          /* Ausfall ist kein Fehler: Die Vorschläge des Shops laufen unverändert weiter. */
        });
    }

    eingabe.addEventListener('input', function () {
      window.clearTimeout(uhr);
      var schl = schluessel(eingabe.value);
      if (schl.length < MIN_ZEICHEN || cache[schl]) {
        abgleichen();
        return;
      }
      var begriff = eingabe.value;
      uhr = window.setTimeout(function () {
        laden(begriff);
      }, VERZOEGERUNG_MS);
    });

    /* Dawn ersetzt die Vorschlagsliste bei jeder Antwort — danach Gruppe neu einsetzen. */
    new MutationObserver(abgleichen).observe(ziel, { childList: true });
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('predictive-search'), einrichten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
